import {useContext} from 'react'
import {DeviceContext} from '../context'
import {DEVICE_TYPE_DESKTOP, DEVICE_TYPE_MOBILE, DEVICE_TYPE_PAD} from '../constants'

export const useIsDesktop = () => {
    const deviceType = useContext(DeviceContext) as string
    return deviceType === DEVICE_TYPE_DESKTOP
}

export const useIsPad = () => {
    const deviceType = useContext(DeviceContext) as string
    return deviceType === DEVICE_TYPE_PAD
}

export const useIsMobile = () => {
    const deviceType = useContext(DeviceContext) as string
    return deviceType === DEVICE_TYPE_MOBILE
}
